import Row from "react-bootstrap/Row";
import { margin, compose } from "styled-system";
import styled from "styled-components";

export const RowEnhanced = styled(Row)`
  ${compose(margin)}
`;

export default RowEnhanced;
